module.exports = __webpack_public_path__ + "static/media/GPW_logo_BW.58f30d9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/GPW_logo_BW.png
// module id = 1116
// module chunks = 0